import { FC } from 'react';

import Icon, { ICON_MAP } from '@mindtickle/icon';
import StringToHTML from '@mindtickle/string-to-html';

import { useMaintenance } from './hooks/useMaintenance';
import { StyledBanner } from './style';
import { BANNER_TYPE, BANNER_ICON_MAP, BannerData, MaintenanceBannerData } from './types';

interface BannerProps {
  bannerData: Record<string, BannerData>;
  setBannerData: Function;
  route: string;
  currentBannerData: BannerData & Partial<MaintenanceBannerData>;
}

const Banner: FC<BannerProps> = ({ setBannerData, route, currentBannerData }) => {
  const {
    bannerText,
    icon,
    isBannerClosable = true,
    bannerType = BANNER_TYPE.WARNING,
  } = currentBannerData;

  const [onMaintenanceClose] = useMaintenance(
    currentBannerData as MaintenanceBannerData,
    setBannerData,
    route
  );
  const iconMapItem = icon || BANNER_ICON_MAP[bannerType];

  return (
    <StyledBanner
      message={<StringToHTML className="banner-text" content={bannerText} />}
      onClose={onMaintenanceClose}
      showIcon={!!iconMapItem}
      bannerType={bannerType}
      icon={<Icon type={ICON_MAP[iconMapItem]} />}
      {...(!isBannerClosable ? { closable: isBannerClosable, closeText: false } : {})}
    />
  );
};

export default Banner;
